import { EditFilled } from '@ant-design/icons';
import { SelectInput, StaticInput } from '@framework/form';
import { Button, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../inputs';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { SelectWidgetWrapper } from '../common/select-widget/SelectWidgetWrapper';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { IAsyncSelectWidget } from './IAsyncSelectWidget';

const FullWidthCompact = styled(Space.Compact)`
  width: 100%;
`;

export interface IAsyncSelectWidgetPreviewProps
  extends IWidgetComponentProps<IAsyncSelectWidget> {}

export function AsyncSelectWidgetPreview(
  props: IAsyncSelectWidgetPreviewProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  if (widget.renderType === 'table') {
    return (
      <ConfigFormItem
        name={'string'}
        label={<RichTextAdvancedRender inline text={options.label} />}
        help={<RichTextAdvancedRender inline text={options.helpText} />}
        layout={{ hideVisualLabel: options.hideLabel }}
        readonly={options.readonly}
      >
        <FullWidthCompact>
          <StaticInput value={''} placeholder={options.placeholder} />
          <Button
            size="large"
            type="primary"
            style={{ width: '130px' }}
            icon={<EditFilled />}
          >
            Scegli
          </Button>
        </FullWidthCompact>
      </ConfigFormItem>
    );
  }

  return (
    <SelectWidgetWrapper {...props} widget={widget}>
      <SelectInput
        name={'async-select-widget'}
        placeholder={options.placeholder}
      />
    </SelectWidgetWrapper>
  );
}
